import { render, staticRenderFns } from "./MedicalSubMenu.vue?vue&type=template&id=1875ebb5&scoped=true"
import script from "./MedicalSubMenu.vue?vue&type=script&lang=ts"
export * from "./MedicalSubMenu.vue?vue&type=script&lang=ts"
import style0 from "./MedicalSubMenu.vue?vue&type=style&index=0&id=1875ebb5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1875ebb5",
  null
  
)

export default component.exports